import React from 'react';
import * as globalEvents from 'core/utils/globalEvents';
import * as customEvents from 'custom/common/utils/customEvents';

export const withCoreEvents = (WrappedComponent) => {
  class ContainerComponent extends React.Component {
    state = {
      isAppLoading: false,
      isAppChanging: false,
    };
    appLoad = async (
      user,
      controlItems,
      formData,
      elementItems,
      interfaceSetupItems,
      allSetupItems,
      updateFormData,
      updateControlItems,
      inforceData
    ) => {
      this.setState({isAppLoading: true});
      await this.appRunAllBusinessRules(
        user,
        controlItems,
        formData,
        elementItems,
        interfaceSetupItems,
        allSetupItems,
        updateFormData,
        updateControlItems,
        inforceData
      );
      this.setState({isAppLoading: false});
    };
    appGetFocus = (
      event,
      controlItems,
      formData,
      elementItems,
      interfaceSetupItems,
      updateFormData,
      updateControlItems
    ) => {
      globalEvents.GlobalGetFocus(
        event.target.name,
        controlItems,
        formData,
        elementItems,
        interfaceSetupItems,
        updateFormData,
        updateControlItems
      );
    };
    appLostFocus = (
      event,
      controlItems,
      formData,
      elementItems,
      interfaceSetupItems,
      updateFormData,
      updateControlItems
    ) => {
      globalEvents.GlobalLostFocus(
        event.target.name,
        controlItems,
        formData,
        elementItems,
        interfaceSetupItems,
        updateFormData,
        updateControlItems
      );
    };
    appChange = async (
      event,
      user,
      controlItems,
      formData,
      elementItems,
      interfaceSetupItems,
      allSetupItems,
      updateFormData,
      updateControlItems,
      inforceData
    ) => {
      this.setState({isAppLoading: true});
      await globalEvents.GlobalChange(
        event.target.name,
        user,
        controlItems,
        formData,
        elementItems,
        interfaceSetupItems,
        allSetupItems,
        updateFormData,
        updateControlItems,
        inforceData
      );
      this.setState({isAppLoading: false});
    };
    appClick = async (
      name,
      user,
      controlItems,
      formData,
      elementItems,
      interfaceSetupItems,
      allSetupItems,
      updateFormData,
      updateControlItems,
      inforceData
    ) => {
      this.setState({isAppLoading: true});
      await globalEvents.GlobalClick(
        name,
        user,
        controlItems,
        formData,
        elementItems,
        interfaceSetupItems,
        allSetupItems,
        updateFormData,
        updateControlItems,
        inforceData
      );
      this.setState({isAppLoading: false});
    };
    appRunAllBusinessRules = (
      user,
      controlItems,
      formData,
      elementItems,
      interfaceSetupItems,
      allSetupItems,
      updateFormData,
      updateControlItems,
      inforceData
    ) => {
      Object.keys(formData).forEach((item) => {
        customEvents.GlobalCustomBusinessRules(
          item,
          user,
          controlItems,
          formData,
          elementItems,
          interfaceSetupItems,
          allSetupItems,
          updateFormData,
          updateControlItems,
          inforceData,
          true
        );
      });
    };
    
    render() {
      return (
        <WrappedComponent
          globalGetFocus={this.appGetFocus}
          globalChange={this.appChange}
          globalLostFocus={this.appLostFocus}
          globalClick={this.appClick}
          onLoad={this.appLoad}
          isAppLoading={this.state.isAppLoading}
        />
      );
    }
  }
  return ContainerComponent;
};
export default withCoreEvents;
